module.exports = __webpack_public_path__ + "files/325472601571f31e1bf00674c368d335.gif";